export default __webpack_public_path__ + "static/media/shop1.6dde8072.jpeg";